import { call, put, takeEvery } from "redux-saga/effects"
import { 
    GET_LEAVE_REQUESTS,
    GET_LEAVE_REQUESTS_SUCCESS,
    GET_LEAVE_REQUESTS_FAIL,
    GET_LEAVE_REQUEST_DETAIL,
    GET_LEAVE_REQUEST_DETAIL_SUCCESS,
    GET_LEAVE_REQUEST_DETAIL_FAIL,
    ADD_LEAVE_REQUEST,
    ADD_LEAVE_REQUEST_SUCCESS,
    ADD_LEAVE_REQUEST_FAIL,
    UPDATE_LEAVE_REQUEST,
    UPDATE_LEAVE_REQUEST_SUCCESS,
    UPDATE_LEAVE_REQUEST_FAIL,
    DELETE_LEAVE_REQUEST,
    DELETE_LEAVE_REQUEST_SUCCESS,
    DELETE_LEAVE_REQUEST_FAIL,
 } from "./actionTypes"


function* onfetchLeaveRequests() {
    try {
      const response = yield call(bkGetLeaveRequests)
      yield put(getLeaveRequestsSuccess(response))
    } catch (error) {
      yield put(getLeaveRequestsFail(error))
    }
  }
  function* onfetchLeaveRequestDetails() {}
  function* onAddLeaveRequest({ payload: leaveRequest }){
      try{
          const response = yield call(bkAddLeaveRequest, leaveRequest)
          yield put()
      } catch (error) {
  
      }
  }
  function* onfetchUpdateRequests() {}
  function* onfetchDeleteRequests() {}
  
  
  
  
  function* leaveSaga() {
    yield takeEvery(GET_LEAVE_REQUESTS, onfetchLeaveRequests)
  }
  
  export default leaveSaga